<template>
  <div>
    <div class="content-i">
      <div class="content-box pb-0">
        <div class="element-wrapper pb-0">
          <h6 class="element-header">
            Posting Summary
          </h6>
          <div class="element-box">
            <div class="element-info my-0">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-mail">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Posting Summary
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="textToggle" v-b-toggle.search class="text-primary os-icon os-icon-arrow-up float-right showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
              <form v-on:submit.prevent="loadPostingSummary">
                <div class="row">
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="client" class="d-block text-center">Client</label>
                        <b-form-select v-model="summaryRequest.client" :options="clients" value-field="short_name" text-field="postroom_label">
                          <template #first>
                            <b-form-select-option value="all"> All </b-form-select-option>
                          </template>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-from" class="d-block text-center"> Date from </label>
                        <datePicker id="date-from" v-model="summaryRequest.date_from" class="form-control text-center" :config="datePickerFromConfig" placeholder="Date from"></datePicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-to" class="d-block text-center"> Date to </label>
                        <datePicker id="date-to" v-model="summaryRequest.date_to" class="form-control text-center" :config="datePickerToConfig" placeholder="Date to"></datePicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between pt-3">
                  <div class="col-lg-12 text-right mt-3">
                    <button v-if="!loading" class="btn btn-primary" type="submit" > Search </button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                      Search
                    </b-button>
                  </div>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="element-wrapper mt-0 pb-0 pt-0">
          <ResponseInfo v-if="getResponseInfo.responseName == 'dailyPostingSummaryView'" />
        </div>
      </div>
    </div>
    <div class="content-i" v-if="calculations">
      <div class="content-box pt-0">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table row">
                <div class="col-lg-12 col-sm-12 col-md-12 text-right">
                  <button v-if="!reportGenerating && !loading" class="btn btn-primary" @click="exportPostingSummaryTableCsv()"> Download table as CSV file </button>
                  <b-button v-else variant="primary" disabled>
                    Download table as CSV file
                  </b-button>
                </div>
              </div>
              <div class="mt-3 col-lg-4 col-sm-4 col-md-4">
                <loading
                    id="widget-loading-spinner"
                    class="align-items-center"
                    :color="'#047bf8'"
                    :loader="'spinner'"
                    :active="loading"
                    :transition="'fade'"
                    :is-full-page="false">
                </loading>

                <b-table-simple responsive striped hover bordered>
                  <b-tbody>
                    <b-tr>
                      <b-th sticky-column class="text-left">Total posting selling price (£):</b-th>
                      <b-td class="text-left">
                        <span v-if="calculations && calculations['selling_price']"> {{calculations['selling_price'] | asNumber(2)}} </span>
                        <span v-else> {{'0' | asNumber(2)}} </span>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-th sticky-column class="text-left"> Total posting cost (£):</b-th>
                      <b-td class="text-left">
                        <span v-if="calculations &&  calculations['cost_price']"> {{calculations['cost_price'] | asNumber(2)}} </span>
                        <span v-else> {{'0' | asNumber(2)}} </span>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-th sticky-column class="text-left"> Total posting margin (£):</b-th>
                      <b-td class="text-left font-weight-bold">
                        <span v-bind:class="[calculations['margin'] >= 0 ? 'text-primary' : 'text-danger']" v-if="calculations && calculations['margin']"> {{calculations['margin'] | asNumber(2)}} </span>
                        <span v-else class="text-primary"> {{'0' | asNumber(2)}} </span>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDownloadData :dataUrl="dataUrl" />
    <div v-if="alertShowing" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import {VclTable} from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"
import moment from "moment"
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { backendUrl } from '@/helpers/backendUrl.js'
import ModalDownloadData from '@/components/Helper_Components/ModalDownloadData.vue'
import Loading from 'vue-loading-overlay'

export default {
  name: 'PostingDailyTallies',
  components: {
    VclTable,
    ResponseInfo,
    datePicker,
    ModalDownloadData,
    Loading,
  },
  data() {
    return {
      alertShowing: false,
      summaryRequest: {
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        client: this.$route.query.client ? this.$route.query.client : 'all',
      },
      visibleSearchBox: true,
      datePickerFromConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerToConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      fields: [
        {key: 'selling_price', label: 'Total posting selling price (£):', sortable: true, thClass: 'hover-pointer'},
        {key: 'cost_price', label: 'Total posting cost (£):', sortable: true, thClass: 'hover-pointer'},
        {key: 'margin', label: 'Total posting margin (£):', sortable: true, thClass: 'hover-pointer'},
      ],
      loading: false,
      reportGenerating: false,
      dataUrl: null,
    }
  },
  methods: {
    exportPostingSummaryTableCsv() {
      this.reportGenerating = true
      this.$store.dispatch('preparePostingSummaryTableCsv', {
        date_from: this.summaryRequest.date_from,
        date_to: this.summaryRequest.date_to,
        client: this.summaryRequest.client,
      })
      .then(response => {
        if (response.fileUrl && response.status === 'success') {
          this.dataUrl = backendUrl() + '/downloadPostingSummaryTableCsv/' + response.fileUrl
          this.alertShowing = true
          this.$root.$emit('bv::show::modal', 'downloadModal')
        }
      })
      .finally(() => {
        this.reportGenerating = false
      })
    },
    loadPostingSummary() {
      this.loading = true
      Object.keys(this.summaryRequest).forEach((key) => (this.summaryRequest[key] === '' || this.summaryRequest[key] === null)  && (this.summaryRequest[key] = undefined))
      this.$router.push({ query: { ...this.$route.query, ...this.summaryRequest } })

      this.$store.dispatch('loadPostingSummary', {
        date_from: this.summaryRequest.date_from,
        date_to: this.summaryRequest.date_to,
        client: this.summaryRequest.client,
      }).finally(() => {
        this.loading = false
        this.visibleSearchBox = false
      })
    },
    loadClients() {
      this.$store.dispatch('loadClientsByEnv')
    },

  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    datePickerFormat() {
      if (this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        return this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
      } else {
        return 'DD-MM-YYYY'
      }
    },
    postingSummary: {
      get() {
        return this.$store.getters.getPostingSummary
      }
    },
    calculations: {
      get() {
        if (this.postingSummary && this.postingSummary.calculations) {
          return this.postingSummary.calculations
        }

        return null
      }
    },
    dateFrom() {
      return this.summaryRequest.date_from
    },
    clients: {
      get() {
        return this.$store.getters.getClientsByEnv
      }
    },
  },
  watch: {
    dateFrom(date) {
      if (date) {
        this.datePickerToConfig.minDate = moment(date, this.datePickerFormat)
      } else {
        this.datePickerToConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
  },
  created() {
    this.loadClients()
    this.datePickerFromConfig.format = this.datePickerFormat
    this.datePickerToConfig.format = this.datePickerFormat

    this.$store.dispatch('alertClearResponse')

    if (!Object.keys(this.$route.query).length) {
      if (!this.$route.query.date_from) {
        this.summaryRequest.date_from = moment().format(this.datePickerFormat)
      }
      if (!this.$route.query.date_to) {
        this.summaryRequest.date_to = moment().format(this.datePickerFormat)
      }
    }

    this.loadPostingSummary()
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.table-responsive >>> .hover-pointer:hover {
  cursor: pointer !important;
}

#textToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}

#textToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.table-responsive >>> .footer-summary {
  background-color: lightgrey !important;
  text-align: center;
}
.table-responsive >>> tfoot th {
  font-weight: bold !important;
  font-size: 10pt !important;
}

.table-responsive >>> .total-results {
  background-color: rgba(4, 123, 248, 0.1);
}

</style>
